import { Injectable } from '@angular/core';
import { HttpRequest, HttpHandler, HttpInterceptor, HTTP_INTERCEPTORS } from '@angular/common/http';
import { TokenStorageService } from '../services/token-storage.service';
import {from, throwError} from "rxjs";
import {fetchAuthSession} from "aws-amplify/auth";
import {catchError, switchMap} from "rxjs/operators";
import {Store} from "@ngrx/store";
import {AppState} from "@app/core/store/app.state";
import * as UserAuthActions from "@app/core/store/userAuth/userAuth.actions";
import {LogoutType} from "@app/core/enums/logout-types.enum";

@Injectable()
export class AuthorizationInterceptor implements HttpInterceptor {
  constructor(
    private token: TokenStorageService,
    private store: Store<AppState>
  ) {}

  // From manually tracked token (old login page)
  // intercept(request: HttpRequest<any>, next: HttpHandler) {
  //   const token = this.token.getIdToken();
  //   const authorizedRequest = token
  //     ? request.clone({ setHeaders: { Authorization: `Bearer ${token}` } })
  //     : request;
  //   return next.handle(authorizedRequest);
  // }

 // From Cognito token
  intercept(request: HttpRequest<any>, next: HttpHandler) {
    return from(fetchAuthSession()).pipe(
      catchError(error => {
        if (this.token.getUser()) {
          this.store.dispatch(UserAuthActions.SessionExpired({ logoutType: LogoutType.INACTIVITY }));
        }

        return throwError(() => error);
      }),
      switchMap(session => {
        const token =  session.tokens?.idToken?.toString();
        const impUser = this.token.getImpersonatedUser();
        if(token) {
          const impHeader: {[p: string]: string} = impUser ? { 'x-impersonation-persona': impUser.id } : {};
          const authorizedRequest = request.clone({ setHeaders: { Authorization: `Bearer ${token}`, ...impHeader }});
          return next.handle(authorizedRequest);
        }
        if (this.token.getUser()) {
          this.store.dispatch(UserAuthActions.SessionExpired({ logoutType: LogoutType.INACTIVITY }));
          return throwError(() => new Error('Session expired'));
        }
        return next.handle(request);
      })
    );
  }
}

export const authorizationInterceptorProviders = [
  {
    provide: HTTP_INTERCEPTORS,
    useClass: AuthorizationInterceptor,
    multi: true
  }
];
